import React from "react";

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';


class CommingSoon extends React.Component {




    render() {
        return (
            <div className="flexcc flex-column w-100 h-100" style={{}}>
                <img className="mb-2" height={80} src="/assets/profile-def.png"/>
                <div className="text-center">
                    <p className="text-bold text-big">Comming Soon</p>
                    <p className="text-semibold text-normal">Stayed Tooned</p>
                </div>
            </div >
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CommingSoon);
